import { Grid, Loader, Segment } from "semantic-ui-react";
import SubscriptionsTable from "./SubscriptionsTable";
import SubscriptionTotals from "./SubscriptionTotals";
import { Button, DateTimeUtils, USER_PERMISSIONS } from "dyl-components";
import { useEffect, useState } from "react";
import subscriptionActions from "actions/subscription";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import EditSubscriptions from "./EditSubscriptions";
import BulkActionsProvider from "shared/context/BulkActionsProvider";

import './index.scss';
import { StringUtils } from "utils";
import RestrictedView from "shared/RestrictedView";

const SubscriptionProducts = ({ isAdmin, hasOutstandingInvoices }) => {
    const dispatch = useDispatch();

    const customer_id = useSelector(state => state.auth.customer_id);
    const { account_id } = useParams();

    const id = isAdmin ? customer_id : account_id;
    const isPaused = useSelector(state => !isAdmin && state.account.account?.customer?.customer_status === 'paused');
    const [params] = useSearchParams();

    useEffect(() => {
        dispatch(subscriptionActions.getNextInvoice(id, { isAdmin }));
    }, [dispatch, id, isAdmin]);
    useEffect(() => {
        dispatch(subscriptionActions.getAllProducts(id, { isAdmin, limit: 10, ...Object.fromEntries(params) }));
    }, [dispatch, id, isAdmin, params]);

    const isReadingProducts = useSelector(state => state.subscription.isReadingProducts);
    const count = useSelector(state => state.subscription.count);
    const [isEditing, setIsEditing] = useState(false);

    const nextInvoice = useSelector(state => state.subscription.next_invoice);
    const isReadingNextInvoice = useSelector(state => state.subscription.isReadingNextInvoice);
    const isDyl = useSelector(state => state.auth.dyl_employee);
    return (
        <div className="SubscriptionProducts">
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.BILLING_EDIT}>
                            <Button disabled={isReadingProducts || count === 0 || hasOutstandingInvoices || isPaused || !isDyl} onClick={() => { setIsEditing(true) }} floated='right' color="primary">Edit Products</Button>
                        </RestrictedView>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <SubscriptionsTable hasOutstandingInvoices={hasOutstandingInvoices} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={4} reversed="computer">
                    {!isReadingNextInvoice ? ['monthly', 'quarterly', 'semi-annually', 'annually'].map(period => {
                        const nextInvoiceForPeriod = nextInvoice[period];
                        return nextInvoiceForPeriod && (
                            <Grid.Column key={period}>
                                <Segment size="tiny">
                                    <SubscriptionTotals
                                        subtotal={nextInvoiceForPeriod.subtotal || 0}
                                        total={nextInvoiceForPeriod.total || 0}
                                        totalDiscount={nextInvoiceForPeriod.discount || 0}
                                        totalFee={nextInvoiceForPeriod.fee || 0}
                                        totalTax={nextInvoiceForPeriod.tax || 0}
                                        label={isDyl || isAdmin ? DateTimeUtils.formatEpochTimezone(
                                            nextInvoiceForPeriod?.next_invoice_date,
                                            DateTimeUtils.WORD_DATE_FORMAT
                                        ) : (period !== "semi-annually" ? StringUtils.capitalize(period) : "Semi-Annually")} />
                                </Segment>
                            </Grid.Column>
                        );
                    }
                    ) : <Loader active inline='centered' />}
                </Grid.Row>
            </Grid>
            <BulkActionsProvider>
                <EditSubscriptions
                    onClose={() => {
                        setIsEditing(false)
                    }}
                    open={isEditing}
                    account_id={id}
                    isAdmin={isAdmin}
                />
            </BulkActionsProvider>
        </div>
    );
};

export default SubscriptionProducts;
